import { IOffer } from '../../../types/offer';

export function getFlatShareTitle(offer: IOffer) {
  return offer.shareAmount ? offer.shareAmount + ' квартиры' : 'доля';
}
